import { ChevronDown, Search } from "lucide-react";
import { useRef, useState, useEffect } from "react";

const data = [
  {
    id: 1,
    name: "Community Aid Initiative",
    role: "NGO",
    documentType: "Registration",
    expire: "2024-12-15",
    status: "Verified",
    lastUpdate: "2023-12-15",
  },
  {
    id: 2,
    name: "City of Harmony",
    role: "Municipality",
    documentType: "Accreditation",
    expire: "2024-12-15",
    status: "Verified",
    lastUpdate: "2023-12-15",
  },
  {
    id: 3,
    name: "Green Valley University",
    role: "University",
    documentType: "License",
    expire: "2024-12-15",
    status: "Verified",
    lastUpdate: "2023-12-15",
  },
  {
    id: 4,
    name: "Volunteer United",
    role: "Volunteer Org",
    documentType: "Registration",
    expire: "2024-12-15",
    status: "Verified",
    lastUpdate: "2023-12-15",
  },
  {
    id: 5,
    name: "Rural Development Agency",
    role: "NGO",
    documentType: "Accreditation",
    expire: "2024-12-15",
    status: "Verified",
    lastUpdate: "2023-12-15",
  },
  {
    id: 6,
    name: "Town of Willow Creek",
    role: "Municipality",
    documentType: "License",
    expire: "2024-12-15",
    status: "Verified",
    lastUpdate: "2023-12-15",
  },
  {
    id: 7,
    name: "Community Aid Initiative",
    role: "NGO",
    documentType: "Registration",
    expire: "2024-12-15",
    status: "Verified",
    lastUpdate: "2023-12-15",
  },
  {
    id: 8,
    name: "Community Aid Initiative",
    role: "NGO",
    documentType: "Registration",
    expire: "2024-12-15",
    status: "Verified",
    lastUpdate: "2023-12-15",
  },
  {
    id: 10,
    name: "Community Aid Initiative",
    role: "NGO",
    documentType: "Registration",
    expire: "2024-12-15",
    status: "Verified",
    lastUpdate: "2023-12-15",
  },
  {
    id: 11,
    name: "Community Aid Initiative",
    role: "NGO",
    documentType: "Registration",
    expire: "2024-12-15",
    status: "Verified",
    lastUpdate: "2023-12-15",
  },
  {
    id: 12,
    name: "Community Aid Initiative",
    role: "NGO",
    documentType: "Registration",
    expire: "2024-12-15",
    status: "Verified",
    lastUpdate: "2023-12-15",
  },
  {
    id: 13,
    name: "Community Aid Initiative",
    role: "NGO",
    documentType: "Registration",
    expire: "2024-12-15",
    status: "Verified",
    lastUpdate: "2023-12-15",
  },
  {
    id: 14,
    name: "Community Aid Initiative",
    role: "NGO",
    documentType: "Registration",
    expire: "2024-12-15",
    status: "Verified",
    lastUpdate: "2023-12-15",
  },
];

const MainCompliance = () => {
  const [openMenu, setOpenMenu] = useState(null);
  const menuRef = useRef(null);

  // Close menu if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setOpenMenu(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="lg:w-[85%] mb-6">
      <div className="">
        <h1 className="font-popinsSemiBold text-xl lg:text-2xl">
          Compliance & Verification Center
        </h1>
      </div>
      <div className="">
        <div className="relative mt-7">
          <input
            type="text"
            placeholder="Search by organization name, role, or document name"
            class="peer w-full font-popinsMedium rounded-md border-2 border-border bg-[#F0F2F5] pl-9 py-2 text-black/50 outline-none transition-all duration-300 ease-in-out focus:border-[#3FC4E3] focus:shadow-[0_0_3px_#3FC4E3]"
          />
          <div className="absolute left-3 top-3">
            <Search size={18} color="#61708A" />
          </div>
        </div>
        <div className="flex flex-wrap gap-4 mt-5" ref={menuRef}>
          {/* Location Menu */}
          <div className="relative">
            <button
              className="px-4 py-2 border rounded-md text-[#121417] font-popinsMedium cursor-pointer bg-[#F0F2F5] shadow-sm hover:bg-gray-100 focus:outline-none flex items-center text-sm gap-x-2"
              onClick={() =>
                setOpenMenu(openMenu === "location" ? null : "location")
              }
            >
              Role Type
              <ChevronDown size={20} />
            </button>
            {openMenu === "location" && (
              <ul className="absolute mt-1 w-56 bg-[#F0F2F5] text-[#121417] text-sm border rounded-md font-popinsRegular shadow-lg z-50">
                <li
                  className="px-4 py-2 hover:bg-gray-100 cursor-pointer border-b border-black/1"
                  onClick={() => {
                    console.log("Location: New York");
                    setOpenMenu(null);
                  }}
                >
                  New York
                </li>
                <li
                  className="px-4 py-2 hover:bg-gray-100 cursor-pointer border-b border-black/1"
                  onClick={() => {
                    console.log("Location: Los Angeles");
                    setOpenMenu(null);
                  }}
                >
                  Los Angeles
                </li>
                <li
                  className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                  onClick={() => {
                    console.log("Location: Chicago");
                    setOpenMenu(null);
                  }}
                >
                  Chicago
                </li>
              </ul>
            )}
          </div>

          {/* Services Menu */}
          <div className="relative">
            <button
              className="px-4 py-2 border rounded-md text-[#121417] font-popinsMedium cursor-pointer bg-[#F0F2F5] flex items-center text-sm gap-x-2 shadow-sm hover:bg-gray-100 focus:outline-none"
              onClick={() =>
                setOpenMenu(openMenu === "Document" ? null : "Document")
              }
            >
              Document Type
              <ChevronDown size={20} />
            </button>
            {openMenu === "Document" && (
              <ul className="absolute mt-1 w-56 text-[#121417] bg-[#F0F2F5] font-popinsRegular text-sm rounded-md shadow-lg z-50">
                <li
                  className="px-4 py-2 hover:bg-gray-100 cursor-pointer border-b border-black/10"
                  onClick={() => {
                    console.log("Services Offered: Cleaning");
                    setOpenMenu(null);
                  }}
                >
                  Cleaning
                </li>
                <li
                  className="px-4 py-2 hover:bg-gray-100 cursor-pointer border-b border-black/10"
                  onClick={() => {
                    console.log("Services Offered: Delivery");
                    setOpenMenu(null);
                  }}
                >
                  Delivery
                </li>
                <li
                  className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                  onClick={() => {
                    console.log("Services Offered: Support");
                    setOpenMenu(null);
                  }}
                >
                  Support
                </li>
              </ul>
            )}
          </div>

          <div className="relative">
            <button
              className="px-4 py-2 border rounded-md text-[#121417] font-popinsMedium cursor-pointer bg-[#F0F2F5] flex items-center text-sm gap-x-2 shadow-sm hover:bg-gray-100 focus:outline-none"
              onClick={() =>
                setOpenMenu(openMenu === "Status" ? null : "Status")
              }
            >
              Status
              <ChevronDown size={20} />
            </button>
            {openMenu === "Status" && (
              <ul className="absolute mt-1 w-56 text-[#121417] bg-[#F0F2F5] font-popinsRegular text-sm rounded-md shadow-lg z-50">
                <li
                  className="px-4 py-2 hover:bg-gray-100 cursor-pointer border-b border-black/10"
                  onClick={() => {
                    console.log("Services Offered: Cleaning");
                    setOpenMenu(null);
                  }}
                >
                  Cleaning
                </li>
                <li
                  className="px-4 py-2 hover:bg-gray-100 cursor-pointer border-b border-black/10"
                  onClick={() => {
                    console.log("Services Offered: Delivery");
                    setOpenMenu(null);
                  }}
                >
                  Delivery
                </li>
                <li
                  className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                  onClick={() => {
                    console.log("Services Offered: Support");
                    setOpenMenu(null);
                  }}
                >
                  Support
                </li>
              </ul>
            )}
          </div>

          <div className="relative">
            <button
              className="px-4 py-2 border rounded-md text-[#121417] font-popinsMedium cursor-pointer bg-[#F0F2F5] flex items-center text-sm gap-x-2 shadow-sm hover:bg-gray-100 focus:outline-none"
              onClick={() =>
                setOpenMenu(openMenu === "Location" ? null : "Location")
              }
            >
              Location
              <ChevronDown size={20} />
            </button>
            {openMenu === "Location" && (
              <ul className="absolute mt-1 w-56 text-[#121417] bg-[#F0F2F5] font-popinsRegular text-sm rounded-md shadow-lg z-50">
                <li
                  className="px-4 py-2 hover:bg-gray-100 cursor-pointer border-b border-black/10"
                  onClick={() => {
                    console.log("Services Offered: Cleaning");
                    setOpenMenu(null);
                  }}
                >
                  Cleaning
                </li>
                <li
                  className="px-4 py-2 hover:bg-gray-100 cursor-pointer border-b border-black/10"
                  onClick={() => {
                    console.log("Services Offered: Delivery");
                    setOpenMenu(null);
                  }}
                >
                  Delivery
                </li>
                <li
                  className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                  onClick={() => {
                    console.log("Services Offered: Support");
                    setOpenMenu(null);
                  }}
                >
                  Support
                </li>
              </ul>
            )}
          </div>
        </div>
      </div>
      <div className="">
        <div className="flex flex-col gap-y-4 lg:gap-y-0 lg:flex-row lg:justify-between mt-5">
          <div className="w-full lg:w-[24%] border border-border rounded-lg shadow px-6 py-6">
            <p className="font-popinsMedium text-base">
              Total Verified Organizations
            </p>
            <p className="font-popinsSemiBold text-2xl pt-2">1,245</p>
          </div>
          <div className="w-full lg:w-[24%] border border-border rounded-lg shadow px-6 py-6">
            <p className="font-popinsMedium text-base">
              Documents Expiring Soon
            </p>
            <p className="font-popinsSemiBold text-2xl pt-2">32</p>
          </div>
          <div className="w-full lg:w-[24%] border border-border rounded-lg shadow px-6 py-6">
            <p className="font-popinsMedium text-base">Expired Documents</p>
            <p className="font-popinsSemiBold text-2xl pt-2">15</p>
          </div>
          <div className="w-full lg:w-[24%] border border-border rounded-lg shadow px-6 py-6">
            <p className="font-popinsMedium text-base">
              Pending Compliance Updates
            </p>
            <p className="font-popinsSemiBold text-2xl pt-2">78</p>
          </div>
        </div>
      </div>

      {/* Table */}
      <div className="bg-white shadow rounded-xl overflow-x-auto panelScroll mt-8">
        <table className="w-full rounded-xl overflow-x-auto">
          <thead className="text-xs  border-b border-gray-300 font-popinsRegular">
            <tr className="font-popinsRegular">
              <th className="text-left text-sm w-[20%] py-6 px-4 font-popinsRegular">
                Organization Name
              </th>
              <th className="text-center text-sm w-[15%] py-3 px-1 font-popinsRegular">
                Role
              </th>
              <th className="text-center text-sm w-[15%] py-3 px-4 font-popinsRegular">
                Document Type
              </th>
              <th className="text-center text-sm w-[12%] py-3 px-4 font-popinsRegular">
                Expiration Date
              </th>
              <th className="text-center text-sm py-3 w-[16%] px-4 font-popinsRegular">
                Status
              </th>
              <th className="text-center text-sm py-3 w-[12%] px-4 font-popinsRegular">
                Last Updated
              </th>
              <th className="text-center text-sm py-3 w-[10%] px-4 font-popinsRegular">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-300">
            {data.map((item, idx) => (
              <tr
                key={idx}
                className="border-b border-gray-200 hover:bg-gray-50 transition"
              >
                <td className="py-3 px-4 font-popinsRegular text-sm">
                  {item.name}
                </td>
                <td className="py-3 px-4 font-popinsMedium text-xs">
                  <div className="bg-gray-100 px-8 flex justify-center py-2 rounded-lg whitespace-nowrap">{item.role}</div>
                </td>
                <td className="py-3 px-4 font-popinsRegular text-sm text-[#61758A] text-center">
                    {item.documentType}
                </td>
                <td className="font-popinsRegular text-sm text-[#61758A] text-center">
                  {item.expire}
                </td> 
                <td className="py-3 px-4">
                  <span
                    className={`inline-flex items-center justify-center w-28 px-4 py-2 rounded-md text-sm font-popinsMedium whitespace-nowrap ${
                      item.status === "Verified"
                        ? "bg-[#3FE36B] text-black"
                        : "bg-[#DFCD00] text-black"
                    }`}
                  >
                    {item.status}
                  </span>
                </td>
                 <td className="font-popinsRegular text-sm text-[#61758A] text-center">
                  {item.lastUpdate}
                </td>
                <td className="py-3 px-4 text-center font-popinsMedium text-[#61758A] cursor-pointer">
                  View
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default MainCompliance;
